import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { getCatalogHeadline } from 'store/ProductCatalog/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const MainHeadingLayout = ({ children, isMobile }) => (
  <div id="catalogHeading">
    <h1 className={cx('component', isMobile && 'mobile')}>{children}</h1>
  </div>
);

MainHeadingLayout.propTypes = {
  children: PropTypes.node,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  children: getCatalogHeadline(state),
  isMobile: isScreenBelow640(state),
});

export default connect(mapStateToProps)(MainHeadingLayout);
